import axios from "axios";
export const StudentRegistation = (url , token , payload) => {
    return async (dispatch) => {
        try {
            const res = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            dispatch({type:"SHOW_LOADER" , Seconds:'getdata'});

            if (res.status === 200) {
                const getMsg = res?.data?.RollNumer +','+ res?.data?.Name +','+ res?.data?.ClassName;
                dispatch({
                    type: 'SHOW_MODAL',
                    response: res.data,
                    severity: 'Success'
                });

                setTimeout(() => {
                    dispatch({type:"SHOW_LOADER" , Seconds:'0'});
                }, 1000);

                return getMsg;  // 👈 return back to caller
            }
        } catch (err) {
            console.error(err);
            throw err; // 👈 so caller can catch error
        }
    };
};
